"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewGroupBy = exports.ViewColorBy = exports.ServiceCancellationType = exports.ShiftCancellationType = exports.JobPayType = exports.DayNumbersArray = exports.NoteEntityType = exports.MetaT = exports.MetaSettingT = exports.SubRosterMasterT = exports.LinkedRosterT = exports.LeaveT = exports.JobT = exports.IgnoredUnavailabilityT = exports.GridExceptions = exports.ClockingT = void 0;
const universal_1 = require("../universal");
const types_roster_server_1 = require("./types-roster-server");
exports.ClockingT = universal_1.t.Object({
    Assignment: (0, universal_1.MaybeT)(universal_1.t.Number()),
    CovidVerified: (0, universal_1.MaybeT)(universal_1.tBoolT),
    Emp: universal_1.t.String(),
    Endpoint: (0, universal_1.MaybeT)(universal_1.tBoolT),
    ID: universal_1.t.Number(),
    IsAuth: (0, universal_1.MaybeT)(universal_1.tBoolT),
    Latitude: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Longitude: (0, universal_1.MaybeT)(universal_1.t.Number()),
    OriginalTime: (0, universal_1.MaybeT)((0, universal_1.DateTimeObjT)()),
    PhKey: (0, universal_1.MaybeT)(universal_1.t.String()),
    SerialNumber: (0, universal_1.MaybeT)(universal_1.t.String()),
    TS: (0, universal_1.DateTimeObjT)(),
    Temperature: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Type: (0, universal_1.MaybeT)(universal_1.t.Number()),
});
class GridExceptions {
    services;
    shifts;
    shiftGaps;
    constructor() {
        this.services = {};
        this.shiftGaps = {};
        this.shifts = {};
    }
    add(index, key, exception) {
        const obj = this[index][key];
        if (obj) {
            obj.add(exception);
        }
        else {
            this[index][key] = new Set([exception]);
        }
    }
    addService(key, exception) {
        this.add('services', key, exception);
    }
    addShift(key, exception) {
        this.add('shifts', key, exception);
    }
    addShiftGap(key, exception) {
        this.add('shiftGaps', key, exception);
    }
}
exports.GridExceptions = GridExceptions;
exports.IgnoredUnavailabilityT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Date: (0, universal_1.DateObjT)(),
    User: universal_1.t.String(),
});
exports.JobT = universal_1.t.Object({
    Active: universal_1.tBoolT,
    CC: universal_1.t.Array(universal_1.t.Number()),
    Classification: universal_1.t.Number(),
    Company: universal_1.t.Number(),
    ContractHours: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ContractHoursMax: (0, universal_1.MaybeT)(universal_1.t.Number()),
    DefaultArea: (0, universal_1.MaybeT)(universal_1.t.Number()),
    DynamicCC: universal_1.tBoolT,
    Employee: universal_1.t.Number(),
    EndDate: (0, universal_1.MaybeT)((0, universal_1.DateObjT)()),
    ID: universal_1.t.Number(),
    IsDefault: universal_1.tBoolT,
    LegacyKey: (0, universal_1.MaybeT)(universal_1.t.Number()),
    PHBR: universal_1.tBoolT,
    PayType: types_roster_server_1.JobPayTypeT,
    StartDate: (0, universal_1.DateObjT)(),
    WorkType: universal_1.t.Union([universal_1.t.Literal('P'), universal_1.t.Literal('C'), universal_1.t.Literal('F')]),
});
exports.LeaveT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    Code: universal_1.t.String(),
    ShortName: universal_1.t.String(),
    Casual: universal_1.tBoolT,
    Enabled: universal_1.tBoolT,
    Transferred: universal_1.tBoolT,
    Costed: universal_1.tBoolT,
    PayrollCategory: universal_1.t.String(),
    PrivacyName: universal_1.t.String(),
});
exports.LinkedRosterT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    MasterRoster: universal_1.t.Number(),
    LinkedRoster: universal_1.t.Number(),
    SubRoster: universal_1.t.Number(),
});
exports.SubRosterMasterT = universal_1.t.Object({
    Key: universal_1.t.Number(),
    Name: universal_1.t.String(),
    Rosters: universal_1.t.Array(universal_1.t.Object({ ID: universal_1.t.Number(), Name: universal_1.t.String() })),
});
exports.MetaSettingT = universal_1.t.Object({
    Description: universal_1.t.String(),
    Hidden: universal_1.t.Boolean(),
    Name: universal_1.t.String(),
    Type: universal_1.t.String(),
    Value: universal_1.t.Any(),
});
exports.MetaT = universal_1.t.Object({
    CompanyName: universal_1.t.String(),
    DefaultActual: universal_1.tBoolT,
    Facility: universal_1.t.Number(),
    HasBilling: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    IsCDC: universal_1.t.Boolean(),
    IsLive: universal_1.t.Boolean(),
    LastRecalc: (0, universal_1.MaybeT)((0, universal_1.DateTimeObjT)()),
    LastRecalcLong: (0, universal_1.MaybeT)((0, universal_1.DateTimeObjT)()),
    Name: universal_1.t.String(),
    PayrollVersion: universal_1.t.String(),
    Settings: universal_1.t.Record(universal_1.t.String(), exports.MetaSettingT),
    SharedClockings: universal_1.tBoolT,
    SubBilling: (0, universal_1.MaybeT)(universal_1.t.Number()),
    SubRoster: universal_1.t.Number(),
    SysVals: universal_1.t.Object({
        SchemaDate: (0, universal_1.DateObjT)(),
        CDCMaxGap: (0, universal_1.MaybeT)(universal_1.t.Number()),
    }),
    SubRosterMasters: (0, universal_1.MaybeT)((0, universal_1.ModelTypeT)(exports.SubRosterMasterT)),
});
var NoteEntityType;
(function (NoteEntityType) {
    NoteEntityType[NoteEntityType["Roster"] = 0] = "Roster";
    NoteEntityType[NoteEntityType["Shift"] = 1] = "Shift";
    NoteEntityType[NoteEntityType["Service"] = 2] = "Service";
    NoteEntityType[NoteEntityType["Employee"] = 3] = "Employee";
    NoteEntityType[NoteEntityType["Client"] = 4] = "Client";
    NoteEntityType[NoteEntityType["ServiceSchedule"] = 5] = "ServiceSchedule";
})(NoteEntityType || (exports.NoteEntityType = NoteEntityType = {}));
exports.DayNumbersArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
var JobPayType;
(function (JobPayType) {
    JobPayType[JobPayType["PayByShift"] = 1] = "PayByShift";
    JobPayType[JobPayType["PayByTask"] = 2] = "PayByTask";
})(JobPayType || (exports.JobPayType = JobPayType = {}));
var ShiftCancellationType;
(function (ShiftCancellationType) {
    ShiftCancellationType[ShiftCancellationType["NotCancelled"] = 0] = "NotCancelled";
    ShiftCancellationType[ShiftCancellationType["CancelledUnpaid"] = 1] = "CancelledUnpaid";
    ShiftCancellationType[ShiftCancellationType["CancelledPaid"] = 2] = "CancelledPaid";
})(ShiftCancellationType || (exports.ShiftCancellationType = ShiftCancellationType = {}));
var ServiceCancellationType;
(function (ServiceCancellationType) {
    ServiceCancellationType[ServiceCancellationType["NotCancelled"] = 0] = "NotCancelled";
    ServiceCancellationType[ServiceCancellationType["CancelledCharged"] = 1] = "CancelledCharged";
    ServiceCancellationType[ServiceCancellationType["CancelledNotCharged"] = 2] = "CancelledNotCharged";
})(ServiceCancellationType || (exports.ServiceCancellationType = ServiceCancellationType = {}));
var ViewColorBy;
(function (ViewColorBy) {
    ViewColorBy[ViewColorBy["ShiftTemplate"] = 0] = "ShiftTemplate";
    ViewColorBy[ViewColorBy["Area"] = 1] = "Area";
    ViewColorBy[ViewColorBy["ServiceType"] = 2] = "ServiceType";
    ViewColorBy[ViewColorBy["ServiceAssigned"] = 3] = "ServiceAssigned";
    ViewColorBy[ViewColorBy["SCHADShiftGroup"] = 4] = "SCHADShiftGroup";
})(ViewColorBy || (exports.ViewColorBy = ViewColorBy = {}));
var ViewGroupBy;
(function (ViewGroupBy) {
    ViewGroupBy[ViewGroupBy["NoGrouping"] = 0] = "NoGrouping";
    ViewGroupBy[ViewGroupBy["Area"] = 1] = "Area";
    ViewGroupBy[ViewGroupBy["Classification"] = 2] = "Classification";
    ViewGroupBy[ViewGroupBy["ShiftTemplate"] = 3] = "ShiftTemplate";
    ViewGroupBy[ViewGroupBy["ServiceType"] = 4] = "ServiceType";
})(ViewGroupBy || (exports.ViewGroupBy = ViewGroupBy = {}));
//# sourceMappingURL=types-roster.js.map